import { Fragment } from 'react';
import { Typography } from '@mui/material';
import { FormControlLabel } from '@components/formControlLabel';
import { RadioButton } from '@components/radioButton/RadioButton';

interface IAddressSuggestion {
  option: string;
  warning?: string;
  checked: boolean;
  value: number | string;
}

export const AddressSuggestion = ({ option, checked, value, warning }: IAddressSuggestion) => {
  return (
    <Fragment key={option}>
      <FormControlLabel
        value={value}
        label={option}
        checked={checked}
        control={<RadioButton />}
        typographyProps={{ sx: { color: 'common.black' } }}
      />
      {checked && warning ? (
        <Typography
          variant='caption'
          display='block'
          sx={{
            color: 'error.light',
            paddingLeft: '35px',
          }}
        >
          {warning}
        </Typography>
      ) : null}
    </Fragment>
  );
};
